import Layout from '@/layout'

const paymentRouter = {
  path: '/payment',
  component: Layout,
  children: [
    {
      path: 'memberPurchase',
      component: () => import('@/views/payment/memberPurchase'),
      name: 'Payment',
      meta: {
        title: 'routeOrder',
        icon: 'shopping',
        code: 'epc:vin'
      }
    }
  ]
}

export default paymentRouter
